import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Analytics from "analytics/util/Analytics";
import _str from "shared/util/_str";
import LineItem from "./LineItem";

import Str from "shared/components/Str";

import "./Product.scss";


const windowSettings = {
	height: 400,
	width: 550,
	top: 0,
	left: 0,
	toolbar: 0,
	location: 0,
	menubar: 0,
	directories: 0,
	scrollbars: 0,
};

const settingsString = Object.keys(windowSettings).map((name) => {
	const value = windowSettings[name];
	return `${name}=${value}`;
}).join(", ");


const Product = ({
	product,
}) => {
	if (!product) {
		return null;
	}

	const {
		description,
		unitName,
		unitNamePlural,
		learnMoreLink,
		formattedInitialUnitPrice,
		formattedSalesTaxes,
		formattedInitialSubtotalPrice,
		formattedInitialSubtotalPriceBase,
		initialTaxes,
		initialCurrency,
	} = product;

	const hasVATTax = initialTaxes.some((tax) => tax.taxType === "VAT");
	const isCurrencyDisplayedInUSD = initialCurrency === "USD";

	const perPrice = `${formattedInitialUnitPrice} / ${unitName}`;

	const unitCount = product.tokensNumber || product.subPeriod;
	const platform = process.env.PLATFORM;

	const totalText = hasVATTax ? _str("Total (VAT included)") : _str("Total");

	return (
		<div className="payment-product">
			<div className="payment-product-description">
				{description}
			</div>

			{learnMoreLink &&
				<div className="payment-product-learn-more">
					<a
						href={learnMoreLink}
						target={platform === "mobile" ? "_blank" : ""}
						onClick={(e) => {
							Analytics.logUIEvent(Analytics.eventNames.paymentLinkLearnMore);

							if (platform === "desktop") {
								e.preventDefault();
								window.open(learnMoreLink, "learnmore", settingsString);
							}
						}}
					>
						<Str>Learn more</Str>
					</a>
				</div>
			}
			<div className={classnames("payment-product-price", {
				"payment-product-price-no-description": !description,
			})}>
				{unitName &&
					<LineItem
						leftLabel={`${unitCount} ${unitCount > 1 ? unitNamePlural : unitName}`}
						rightLabel={perPrice}
					/>
				}
				{!!formattedSalesTaxes &&
					<LineItem
						leftLabel={_str("Tax")}
						rightLabel={formattedSalesTaxes}
					/>
				}
				<LineItem
					leftLabel={totalText}
					rightLabel={formattedInitialSubtotalPrice}
				/>
				{!isCurrencyDisplayedInUSD &&
					<LineItem
						leftLabel={_str("Charged as")}
						rightLabel={formattedInitialSubtotalPriceBase}
					/>
				}
			</div>
		</div>
	);
};

Product.propTypes = {
	product: PropTypes.object,
};

Product.defaultProps = {
	product: null,
};

export default Product;



// WEBPACK FOOTER //
// ./src/apps/payment/components/Product/index.jsx